export default "__VITE_ASSET__BYzOoW4A__"